import { availabilityStatus } from '~/modules/availability/utils/orderEligibility.ts';

/**
 * @param {import('../composables/useAvailabilityBigTicket').AvailabilityBigTicketParserData} availabilityInfo
 */

export const availabilityBigTicketParser = (availabilityInfo) => {
  const { availabilityData, zipCode, lookupIds } = availabilityInfo;
  /** @type {string}  */
  const objectKey = `${zipCode}_${lookupIds}`;
  const currentZipCodeAvailabilityData = availabilityData[objectKey];

  /** @type {{ [key: number]: import('../composables/useAvailabilityBigTicket').BigTicketAvailability }} */
  const parsedAvailability = {};

  /**
   * @param {{
   *   deliverability: {
   *     deliverabilityMessage: string,
   *     status: string,
   *   }
   * }} upc
   */
  const getUpcStatus = (upc) => {
    const { status, deliverabilityMessage } = (upc && upc.deliverability) || {};

    return availabilityStatus(deliverabilityMessage, status);
  };

  /**
   * @param { import('../composables/useAvailabilityBigTicket').BigTicketAvailabilityProductData } productData
   */

  const setAvailabilityUpcsObject = (productData) => {
    const { upcs = [] } = productData;
    upcs.forEach((upcData) => {
      const { available, showUnavailableMessage } = getUpcStatus(upcData);
      upcData.bigTicketAvailable = available;
      upcData.showUnavailableMessage = showUnavailableMessage;
      parsedAvailability[upcData.upcId] = upcData;
    });
  };

  /**
   * @param { import('../composables/useAvailabilityBigTicket').BigTicketAvailabilityProductDataDefault } data
   */

  const buildUpcsWithAvailability = (data) => {
    if (Array.isArray(data)) {
      data.forEach((productData) => setAvailabilityUpcsObject(productData));
    }
  };

  const productArray = currentZipCodeAvailabilityData?.products?.product;

  buildUpcsWithAvailability(productArray);

  return parsedAvailability;
};
export default availabilityBigTicketParser;
